import axios from "axios";
import { getBackendUrl } from "../config";

const MAX_LOGS_PER_WINDOW = 20;
const WINDOW_MS = 60 * 1000;

let sentInWindow = 0;
let windowStartedAt = Date.now();
const frontendLogApi = axios.create({
  baseURL: getBackendUrl(),
  withCredentials: true
});

frontendLogApi.interceptors.request.use(config => {
  const tokenStorage = localStorage.getItem("token");
  if (tokenStorage) {
    let parsedToken = tokenStorage;
    try {
      parsedToken = JSON.parse(tokenStorage);
    } catch (_error) {
      parsedToken = tokenStorage;
    }
    config.headers.Authorization = `Bearer ${parsedToken}`;
  }
  return config;
});

const canSendNow = () => {
  const now = Date.now();
  if (now - windowStartedAt >= WINDOW_MS) {
    windowStartedAt = now;
    sentInWindow = 0;
  }

  if (sentInWindow >= MAX_LOGS_PER_WINDOW) {
    return false;
  }

  sentInWindow += 1;
  return true;
};

const normalizeErrorMessage = (errorLike) => {
  if (!errorLike) return "Erro desconhecido";
  if (typeof errorLike === "string") return errorLike;
  if (errorLike?.message) return String(errorLike.message);
  try {
    return JSON.stringify(errorLike);
  } catch (_e) {
    return String(errorLike);
  }
};

export const sendFrontendLog = async ({
  level = "error",
  event = "frontend.error",
  message,
  category = "sistema",
  subcategory = "frontend",
  source = "frontend",
  context = {}
}) => {
  if (!canSendNow()) return;

  try {
    await frontendLogApi.post("/internal-audit/api/frontend-logs", {
      level,
      event,
      message,
      category,
      subcategory,
      source,
      context
    });
  } catch (_error) {
    // Evita loop de erro de log.
  }
};

export const registerGlobalFrontendErrorHandlers = () => {
  if (window.__frontendLogHandlersRegistered) return;
  window.__frontendLogHandlersRegistered = true;

  window.addEventListener("error", (event) => {
    const message = normalizeErrorMessage(event?.error || event?.message);
    sendFrontendLog({
      level: "error",
      event: "frontend.window.error",
      message,
      source: "window.onerror",
      context: {
        filename: event?.filename || null,
        lineno: event?.lineno || null,
        colno: event?.colno || null
      }
    });
  });

  window.addEventListener("unhandledrejection", (event) => {
    const reason = event?.reason;
    const message = normalizeErrorMessage(reason);
    sendFrontendLog({
      level: "error",
      event: "frontend.unhandledrejection",
      message,
      source: "window.unhandledrejection",
      context: {
        reasonType: typeof reason
      }
    });
  });
};

export const logHttpError = (error) => {
  const status = error?.response?.status || null;
  const method = String(error?.config?.method || "").toUpperCase();
  const url = String(error?.config?.url || "");
  const backendError = error?.response?.data?.error || null;
  const message = normalizeErrorMessage(error);

  sendFrontendLog({
    level: status && status < 500 ? "warn" : "error",
    event: "frontend.http.error",
    message,
    source: "axios.interceptor",
    context: {
      status,
      method,
      url,
      backendError
    }
  });
};
